import FormField from "../../../common/forms/FormField";
import deleteIcon from "../../../../assets/icons/delete.png";
import { commonFieldOptionEnums, fieldNameEnums } from "../apiPageHelper";

const ArrayFields = ({
    subField,
    dataTypes,
    updateArraySubField,
    stepIndex,
    dropdownData,
    removeArraySubField,
    handleOpenConnectedFieldModal,
    parentFieldId,
    isTestConnection = false,
    isSuccess = false,
    updatePopField = () => {},
    inputFields,
    outputFields
}) => {
    const indentStyle = {
        maxWidth: "200px"
    };
    const fieldName = isSuccess ? fieldNameEnums.RETURN_VALUE : fieldNameEnums.FIELD_VALUE;
    const title = isSuccess ? "Returned Value" : "Field Value";
    return (
        <>
            <div className="w-100 flex flex-col gap-16px mb-16 ml-32px">
                <div style={{ display: "flex", flexDirection: "column" }} className="w-100">
                    <div className="w-100 flex gap-16px">
                        <div className="dropdown-selector2" style={indentStyle}>
                            <i
                                className="fa-solid fa-arrow-right p-absolute"
                                style={{ left: "-22px", top: "33px", color: "white" }}></i>
                            <FormField
                                type="dropdown"
                                title="Type"
                                tooltip="Type"
                                dropdownData={dataTypes}
                                value={subField.type}
                                requiredType={isTestConnection ? "locked" : "mandatory"}
                                assistiveText=""
                                varName="type"
                                onTextChange={e => {
                                    updateArraySubField(stepIndex, parentFieldId, subField.id, "type", e?.value);
                                }}
                            />
                        </div>
                        <div className="simple" style={indentStyle}>
                            <FormField
                                type="text"
                                title="Name"
                                tooltip="Name"
                                requiredType={isTestConnection ? "locked" : "mandatory"}
                                assistiveText=""
                                varName="name"
                                value={subField?.name}
                                onTextChange={e =>
                                    updateArraySubField(stepIndex, parentFieldId, subField.id, "name", e)
                                }
                            />
                        </div>
                        <div className="dropdown-selector2" style={indentStyle}>
                            <FormField
                                className="w-100"
                                type="dropdown"
                                title="Value"
                                tooltip="Value"
                                dropdownData={dropdownData}
                                dropdownSettings={{ hasLockedFields: true }}
                                requiredType={isTestConnection ? "locked" : "mandatory"}
                                assistiveText=""
                                varName="value"
                                value={
                                    subField.connectFieldName ||
                                    subField.value ||
                                    subField.extraFieldName ||
                                    subField?.returnFieldName
                                }
                                onTextChange={e => {
                                    const selectedValue = e?.value;
                                    const isCreateNewConnectField = selectedValue === commonFieldOptionEnums.CONNECTED;
                                    const isPredefined = selectedValue === commonFieldOptionEnums.PREDEFINED;

                                    if (isCreateNewConnectField) {
                                        handleOpenConnectedFieldModal();
                                        return;
                                    }

                                    if (isPredefined) {
                                        updateArraySubField(
                                            stepIndex,
                                            parentFieldId,
                                            subField.id,
                                            "value",
                                            selectedValue
                                        );
                                        return;
                                    }

                                    let key = fieldNameEnums.CONNECTED_FIELD;
                                    if (inputFields?.some(f => f.value === selectedValue)) {
                                        key = fieldNameEnums.EXTRA_FIELD;
                                    } else if (outputFields?.some(f => f.value === selectedValue)) {
                                        key = fieldNameEnums.RETURN_FIELD;
                                    }
                                    updateArraySubField(stepIndex, parentFieldId, subField.id, key, selectedValue);
                                }}
                            />
                        </div>
                        {(subField?.value === commonFieldOptionEnums.PREDEFINED || subField?.predefinedValue) && (
                            <FormField
                                type="text"
                                title="Predefined Value"
                                tooltip="Predefined Value"
                                requiredType={isTestConnection ? "locked" : "mandatory"}
                                assistiveText=""
                                varName="predefinedValue"
                                value={subField?.predefinedValue}
                                onTextChange={e =>
                                    updateArraySubField(
                                        stepIndex,
                                        parentFieldId,
                                        subField.id,
                                        fieldNameEnums.PREDEFINED_FIELD,
                                        e
                                    )
                                }
                            />
                        )}
                        {!subField?.predefinedValue && isTestConnection && (
                            <div className="dropdown-selector5 input-width">
                                <FormField
                                    type="text"
                                    title={title}
                                    tooltip={title}
                                    requiredType={"mandatory"}
                                    assistiveText=""
                                    varName={fieldName}
                                    value={subField?.fieldValue || subField?.returnValue}
                                    onTextChange={e => {
                                        updatePopField(stepIndex, fieldName, e, subField.id);
                                    }}
                                />
                            </div>
                        )}
                        {!isTestConnection && (
                            <div className="cursor-pointer" style={{ alignSelf: "center" }}>
                                <div
                                    className="table-list-action-dropdown"
                                    onClick={() => removeArraySubField(stepIndex, parentFieldId, subField.id)}>
                                    <div className="frame-74">
                                        <div className="align-items-center justify-center p-4px">
                                            <img className="trash-01" src={deleteIcon} alt="" height={"20px"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {subField?.type === "Array Fields" && (
                <div className="ml-32px mt-8">
                    <div className="ml-32px mt-8">
                        {subField?.arrayFields?.map(innerField => (
                            <ArrayFields
                                key={innerField.id}
                                subField={innerField}
                                stepIndex={stepIndex}
                                dataTypes={dataTypes}
                                parentFieldId={subField.id}
                                updateArraySubField={updateArraySubField}
                                dropdownData={dropdownData}
                                removeArraySubField={removeArraySubField}
                                handleOpenConnectedFieldModal={handleOpenConnectedFieldModal}
                                isSuccess={isSuccess}
                                isTestConnection={isTestConnection}
                                updatePopField={updatePopField}
                            />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ArrayFields;
